export enum CommunityType {
  Residential = 'saleCommunity',
  Lots = 'communityLot',
  Lease = 'communityLease'
}
